import { render, staticRenderFns } from "./direccion.vue?vue&type=template&id=7a4739cb&"
import script from "./direccion.vue?vue&type=script&lang=js&"
export * from "./direccion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports